import React from "react"
import Icon from "@kit/design/icon"
import Badge from "@kit/design/badge"
import { Link } from "react-rb"
import { MenuLink } from "@reach/menu-button"
import { PaidFeatureBadge } from "./paid-feature-badge"

const NavLink = ({
  href,
  icon,
  iconColor,
  label,
  content,
  isPaidFeature = false,
  canUseFeature = true,
  userOnTrial = false,
  newTab = false,
  showBetaBadge = false
}) => {
  const ICON_STYLES = "mr-4 overflow-visible"
  const LINK_STYLES =
    "h-full flex p-2 rounded hover:no-underline hover:text-gray-900 focus:outline-blue focus:no-underline focus:bg-gray-50"
  const showPaidBadge = isPaidFeature && (!canUseFeature || userOnTrial)
  return (
    <MenuLink
      as={Link}
      to={href}
      className={`main-link ${LINK_STYLES}`}
      target={newTab ? "_blank" : undefined}
    >
      <Icon name={icon} className={`${ICON_STYLES} ${iconColor}`} aria-hidden />
      <div className="leading-6">
        <div className="font-semibold text-base flex items-center text-gray-900">
          {label}
          {showPaidBadge && <PaidFeatureBadge className="ml-2" />}
          {showBetaBadge && (
            <Badge color="yellow" variant="light" className="ml-2">
              Beta
            </Badge>
          )}
        </div>
        <p className="mt-2 text-gray-800">{content}</p>
      </div>
    </MenuLink>
  )
}

export default NavLink
